<template>
  <v-card>
    <v-toolbar class="text-h6 mx-1 mt-1 mb-3" style="width: 93.9vw">
      Payment Invoice
    </v-toolbar>
    <div class="overflow-y-auto pt-2" style="max-height: 510px;">
      <unit-plan-summary invoiceStep />
    </div>
  </v-card>
</template>

<script>
import UnitPlanSummary from "@/modules/accounts-receivable/components/UnitPlanSummary";
export default {
  name: "PlanInvoice",
  components: { UnitPlanSummary }
};
</script>
